export class StringTools {
    static simplify(str: string): string {
        let text = str.trim().toLowerCase().replace(/ /g, '-');
        // replace / with -
        text = text.replace(/\//g, '-');
        const replace: Record<string, string> = {
            ä: 'ae',
            ö: 'oe',
            ü: 'ue',
            ß: 'ss',
        };

        for (const [key, val] of Object.entries(replace)) {
            text = text.replaceAll(key, val);
        }

        // Diakritika entfernen (àéî… -> aei…)
        return text
            .normalize('NFD')
            .replace(/\p{Diacritic}/gu, '');
    }

    public static currencyString(value: number): string {
        return value.toLocaleString('de-DE', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
        }) + ' €';
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    public static showPrice(article: any): boolean {
        const excludedCategories = [
            'Module Spiellandschaften',
            'Melamini Module für Holzpfosten',
            'Melamini Module für Metallpfosten',
            'Melamini Module Optik Burg',
            'Module Klettern',
        ];
        let showPrice = true;
        article.categories.forEach((category: any) => {
            if (excludedCategories.includes(category.name) || excludedCategories.includes(category.parent?.name)) {
                showPrice = false;
            }
        });

        return showPrice;
    }
}
